import { API_BASE_URL } from '../config/api';
import { getAuthToken } from './auth';

const formatApiError = (data, fallback) => {
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (typeof data.detail === 'string') return data.detail;
  if (typeof data.message === 'string') return data.message;
  if (Array.isArray(data.detail)) {
    const parts = data.detail
      .map((item) => {
        if (!item) return null;
        if (typeof item === 'string') return item;
        if (typeof item.msg === 'string') return item.msg;
        if (typeof item.message === 'string') return item.message;
        return null;
      })
      .filter(Boolean);
    return parts.length ? parts.join('; ') : fallback;
  }
  return fallback;
};

export const canStartInterview = async ({ vacancyId } = {}) => {
  const token = getAuthToken();
  if (!token) return { ok: false, unauthorized: true };

  const url = new URL(`${API_BASE_URL}/api/interviews/can_start`);
  if (vacancyId) url.searchParams.set('vacancy_id', vacancyId);

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (response.status === 401) return { ok: false, unauthorized: true };

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    return { ok: false, message: formatApiError(data, 'Failed to check subscription status.') };
  }

  if (data?.can_start) return { ok: true };
  return { ok: false, message: formatApiError(data, 'Interview limit reached. Please upgrade your plan.') };
};

